<app-material-auto-complete
  [formatter]="organisationFormatter"
  [ngModel]="_value"
  (ngModelChange)="valueChanged($event)"
  name="organisation"
  [items]="_organisations"
  [placeholder]="_placeholder"
  [disabled]= "_disabled"
  [required]="required">
</app-material-auto-complete>